/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import eventHub from "./eventHub";

require('./bootstrap');

window.Vue = require('vue');
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import HighchartsVue from 'highcharts-vue';
import Multiselect from './components/Select/VueMultiselectExtended';
import DatePicker from './components/DatePicker/DatePickerExtended';
import VueHtmlToPaper  from './components/Print/my-vue-html-to-paper/index.js';

const print_options = {
	name: '_blank',
	specs: [
		'fullscreen=yes',
		'titlebar=yes',
		'scrollbars=yes'
	],
	styles: [
		'/css/app.css?_t=' + new Date().valueOf(),
		'/css/design.css?_t=' + new Date().valueOf(),
		'/css/print.css?_t=' + new Date().valueOf(),
	]
};

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(HighchartsVue);
Vue.use(VueHtmlToPaper , print_options);

// Vue.config.devtools = true;

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
	fieldsBagName: 'vee-fields',
});

import Notifications from 'vue-notification'
Vue.use(Notifications);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
	attempt: 1,
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example-component', require('./components/ExampleComponent.vue'));
Vue.component('Importer', require('./components/Importer/Importer'));
Vue.component('lang', require('./components/Lang/Lang'));
Vue.component('notification', require('./components/Alert/Notification'));
Vue.component('modal', require('./components/Modal/Modal'));
Vue.component('modal-message', require('./components/Modal/ModalMessage'));
Vue.component('listing', require('./components/Table/Table'));
Vue.component('sort-header', require('./components/Table/SortHeader'));
Vue.component('plain-listing', require('./components/Table/PlainList'));
Vue.component('plain-listing-tbody', require('./components/Table/PlainListTbody'));
Vue.component('thumb-listing', require('./components/Table/ThumbList'));
Vue.component('side-menu', require('./components/Modules/Menu'));
Vue.component('drag-drop-ordering', require('./components/DragDropOrdering/DragDropOrdering'));
Vue.component('filter-group-select', require('./components/Select/FilterGroup'));
Vue.component('filter-select', require('./components/Select/Filter'));
Vue.component('filter-date-range', require('./components/Select/FilterDateRange'));
Vue.component('choice', require('./components/Select/Choice'));
Vue.component('form-container', require('./components/FormContainer'));
Vue.component('multiselect', Multiselect);
Vue.component('user-picker', require('./components/UserPicker/UserPicker'));
Vue.component('date-picker', DatePicker);
Vue.component('cus-date-picker', require('./components/DatePicker/vue2-datepicker-cus'));
Vue.component('multi-date-picker', require('./components/DatePicker/MultiDatePicker'));
Vue.component('calendar', require('./components/Calendar/Calendar'));
Vue.component('setting', require('./components/Modules/system-management/administrator/Setting'));
Vue.component('admin-permission-form', require('./components/Modules/system-management/administrator/AdminPermissionForm'));
Vue.component('admin-user-permission-form', require('./components/Modules/system-management/administrator/AdminUserPermissionForm'));
Vue.component('role-form', require('./components/Modules/system-management/administrator/RoleForm'));
Vue.component('administrator', require('./components/Modules/system-management/administrator/Administrator'));
Vue.component('setting', require('./components/Modules/system-management/administrator/Setting'));
Vue.component('administrator-quick-add', require('./components/Modules/system-management/administrator/QuickAdd'));
Vue.component('file-uploader', require('./components/Uploader/FileUploader'));
Vue.component('shortcut-quick-add', require('./components/Modules/user-preference/ShortcutQuickAdd'));
Vue.component('upload-zone', require('./components/Uploader/UploadZone'));
Vue.component('media-modal', require('./components/Modal/MediaModal'));
Vue.component('digital-channel-media-picker', require('./components/DigitalChannelMediaPicker/DigitalChannelMediaPicker'));
Vue.component('admission', require('./components/Admission/Admission'));
Vue.component('admission-interview', require('./components/Admission/AdmissionInterview'));
Vue.component('module-push-notification', require('./components/Notification/ModulePushNotification'));
Vue.component('copy-to-clipboard', require('./components/Copy/CopyToClipBoard'));

require('./user_picker_components');

window.eventHub = eventHub;



// WEBPACK FOOTER //
// ./resources/assets/js/_core1.js